import { render, staticRenderFns } from "./CatalogItemSmall.vue?vue&type=template&id=291b0314&scoped=true"
import script from "./CatalogItemSmall.vue?vue&type=script&lang=ts"
export * from "./CatalogItemSmall.vue?vue&type=script&lang=ts"
import style0 from "./CatalogItemSmall.vue?vue&type=style&index=0&id=291b0314&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291b0314",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QCardSection,QImg,QIcon});
